import { ReactElement } from 'react';

function NotFound(): ReactElement {
  return <div> Request path is not found </div>;
}

export default NotFound;
